import { requestCallCenter, unwrapEnvelopeValue } from "./CallCenterApi";

export const listAlerts = async ({ page = 0, size = 20, status, agentUserId, openOnly } = {}) => {
  const params = { page, size };
  if (status) params.status = status;
  if (agentUserId) params.agentUserId = agentUserId;
  if (openOnly === false) params.openOnly = "false";
  else if (openOnly === true) params.openOnly = "true";
  const envelope = await requestCallCenter({
    method: "get",
    url: "alerts",
    params,
  });
  return unwrapEnvelopeValue(envelope, "Failed to load alerts");
};

export const getAlertSummary = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "alerts/summary",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load alert summary");
};

export const getAlert = async (alertId) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: `alerts/${alertId}`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to load alert");
};

export const listAlertEvents = async (alertId) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: `alerts/${alertId}/events`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to load alert events");
};

export const acknowledgeAlert = async (alertId, note) => {
  const envelope = await requestCallCenter({
    method: "patch",
    url: `alerts/${alertId}/acknowledge`,
    data: note ? { note } : {},
  });
  return unwrapEnvelopeValue(envelope, "Failed to acknowledge alert");
};

export const resolveAlert = async (alertId, { resolutionNote, reassignToUserId } = {}) => {
  const envelope = await requestCallCenter({
    method: "patch",
    url: `alerts/${alertId}/resolve`,
    data: {
      ...(resolutionNote ? { resolutionNote } : {}),
      ...(reassignToUserId ? { reassignToUserId } : {}),
    },
  });
  return unwrapEnvelopeValue(envelope, "Failed to resolve alert");
};

export const getAlertReport = async ({ startDate, endDate }) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "alerts/report",
    params: { startDate, endDate },
  });
  return unwrapEnvelopeValue(envelope, "Failed to load alert report");
};

export const getSlaConfig = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "admin/sla-config",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load SLA config");
};

export const getSlaConfigMetadata = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "admin/sla-config/metadata",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load SLA config metadata");
};

export const saveSlaConfig = async (configs) => {
  const envelope = await requestCallCenter({
    method: "put",
    url: "admin/sla-config",
    data: configs,
  });
  return unwrapEnvelopeValue(envelope, "Failed to save SLA config");
};

export const getSupervisorOptions = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "admin/supervisors",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load supervisors");
};

export const getAdminAgentOptions = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "admin/agents",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load call agents");
};

export const getAgentSupervisors = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "admin/agent-supervisors",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load agent supervisors");
};

export const saveAgentSupervisors = async (mappings) => {
  const envelope = await requestCallCenter({
    method: "put",
    url: "admin/agent-supervisors",
    data: mappings,
  });
  return unwrapEnvelopeValue(envelope, "Failed to save agent supervisors");
};
